export default {
    "Bem vindo(a) ao": "Welcome to",
    "Entre com suas credenciais": "Enter your credentials",
    "do Ginfo abaixo": "from Ginfo below",
    "Empresa": "Country",
    "empresa_login": "",
    "Selecione a empresa": "Select the company",
    "E-mail": "Email",
    "Senha": "Password",
    "Lembrar de mim": "Remember me",
    "Entrar": "Sign in",
    "Solicite seu acesso": "Request access",

    "Portugues": "Portuguese",
    "Mercosul": "Mercosur",
    "Ingles": "English",
    "Frances": "French",
    "Alemao": "German",
    "Holandes": "Dutch",

    'Carregando': 'Loading',
    'TODOS': 'ALL',
    'BELGIUM': 'BELGIUM',
    'GERMANY': 'GERMANY',
    'SELECIONE_O_PAIS': 'Select the country',
    'PAIS': 'Country',
    "inicio": "Home",
    "bem_vindo": "Welcome to",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Smart insights for faster, safer, and more strategic decisions",
    "acessados_recentemente": "Recently accessed",
    "agora": "now",
    "ha": "",
    "minutos": "min ago",
    "horas": "h ago",
    "ontem": "yesterday",
    "dias": "days ago",
    "semanas": "weeks ago",
    "buscar_relatorio": "Search report",
    "nenhum_relatorio_encontrado": "No reports found.",
    "acesso_power_bi": "Power BI Access",
    "ajuda": "Help",
    "sair": "Logout",
    "buscar_abrir_relatorio": "Search and open report",
    "mostrar_senha": "Show password",
    "ocultar_senha": "Hide password",
    "esqueceu_senha": "Forgot your password?",
    "login_frase_inicio": "Better decisions start with",
    "login_frase_destaque": "the right information",
    "login_frase_2": "the right moment",
    "login_frase_3": "the right place",
    "recarregar_relatorio": "Refresh report",
    "fechar_aba": "Close tab",
    "horarios_atualizacao": "Update times",
    "Login incorreto, insira as informações novamente": "Incorrect login, please enter the information again",
    "tutorial_desta_tela": "Tutorial for this screen",
    "fechar": "Close",
    "carregando_tutorial": "Loading tutorial...",
    "tutorial_indisponivel": "Tutorial unavailable for this screen right now.",
    "passo": "Step"
}
